<template>
	<div class="balanceMatching">
		<div class="upload_file" v-if="!matchingData">
			<div class="title">上传余额文件</div>
			<el-upload
				class="upload_body"
				drag
				action=""
				:show-file-list="false"
				:multiple="false"
				accept=".xls,.xlsx"
				:http-request="uploadFile"
				v-loading="uploadLoading"
			>
				<div class="el-upload__text">
					<h2>点击选择或拖拽 Excel 文件到此处</h2>
					<h4>支持 .xlsx、.xls，单文件不超过 10 MB</h4>
					<em>
						<el-button type="primary">选择 Excel</el-button>
					</em>
				</div>
			</el-upload>
		</div>

		<!-- 匹配明细展示 -->
		<matchingResult
			v-else
			:matchingData="matchingData"
			@reUpload="() => (matchingData = null)"
		></matchingResult>
	</div>
</template>

<script>
import matchingResult from './component/matchingResult.vue';

import googleads from '@/backend/services/googleAds/googleAds.js';

export default {
	name: 'balanceMatching',
	components: { matchingResult },
	data() {
		return {
			uploadLoading: false, // 上传加载状态
			matchingData: null, // 匹配数据
		};
	},
	methods: {
		/**
		 * 上传余额匹配文件
		 * @param {File} file - 上传的文件
		 */
		async uploadFile({ file }) {
			try {
				this.uploadLoading = true;

				// 检查文件类型
				const allowedTypes = [
					'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
					'application/vnd.ms-excel', // .xls
				];

				if (!allowedTypes.includes(file.type)) {
					this.$message.error('请上传 Excel 文件（.xlsx 或 .xls 格式）');
					return;
				}

				// 检查文件大小（限制为 10MB）
				const maxSize = 10 * 1024 * 1024; // 10MB
				if (file.size > maxSize) {
					this.$message.error('文件大小不能超过 10MB');
					return;
				}

				// 调用导入接口
				let res = await googleads.balanceMatchImport(file);

				this.matchingData = {
					...res,
					fileName: file.name, // 文件名，例：周报数据.xlsx
				};
				this.uploadLoading = false;
			} catch (error) {
				this.uploadLoading = false;
				this.$message.error('文件上传失败，请重试');
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.balanceMatching {
	.upload_file {
		background-color: white;
		border-radius: 8px;
		border: 1px solid rgb(227, 226, 226);
		padding: 10px 20px;

		.title {
			font-size: 18px;
			font-weight: 600;
			margin-bottom: 10px;
		}

		.upload_body {
			width: 100%;
			::v-deep .el-upload {
				width: 100%;

				.el-upload-dragger {
					width: 100%;
					height: 250px;
					display: flex;
					justify-content: center;
					align-items: center;

					.upload__text {
					}
				}
			}
		}
	}
}
</style>
